import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TN2424Icon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TN2424IconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 4V19H22V4H2Z"
        fill="#E31D1C"
      />
      <mask
        id="mask0_1813_990"
        mask-type="luminance"
        maskUnits="userSpaceOnUse"
        x="2"
        y="4"
        width="20"
        height="15"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 4V19H22V4H2Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_1813_990)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 16.5C14.7614 16.5 17 14.2614 17 11.5C17 8.73858 14.7614 6.5 12 6.5C9.23858 6.5 7 8.73858 7 11.5C7 14.2614 9.23858 16.5 12 16.5Z"
          fill="#F7FCFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.8766 15.0317C12.8766 15.0317 10.2413 14.3128 10.2413 11.4834C10.2413 8.65404 12.8766 7.87346 12.8766 7.87346C11.7869 7.45171 8.59791 8.09882 8.59791 11.4834C8.59791 14.868 11.8758 15.4775 12.8766 15.0317ZM12.7313 10.8679L11.4238 11.3456L12.829 11.8368L12.8763 13.1524L13.7315 12.1303L15.1416 12.2304L14.1256 11.4016L14.7375 10.2046L13.5423 10.6069L12.7143 9.57198L12.7313 10.8679Z"
          fill="#E31D1C"
        />
      </g>
    </svg>
  );
};

export default TN2424Icon;
